'use strict';

import { fetchJson } from '../utils/fetchJson';

/**
 * Leaderboards
 */
class Leaderboards {
  /**
   * Constructor of Leaderboards.
   * @param {Object} options
   * @param {Object} player
   * @return {*}
   */
  constructor(options, player) {
    this._options = options;
    this._player = player;
  }

  async getLeaderboardDescription(code) {
    return new Promise((resolve, reject) => {
      const headers = new Headers();
      headers.append('Game-Key', this._options.gameId);
      headers.append('Player-Token', this._player.token);
      let url = `${this._options.apiDomain}/highscore/${code}`;
      fetchJson(url, {
        method: 'GET',
        headers: headers,
      })
        .then((response) => resolve(response.data))
        .catch((error) => reject(error));
    });
  }

  async setLeaderboardScore(code, score, extraData) {
    return new Promise((resolve, reject) => {
      const headers = new Headers();
      headers.append('Game-Key', this._options.gameId);
      headers.append('Player-Token', this._player.token);
      let url = `${this._options.apiDomain}/highscore/${code}/score`;
      fetchJson(url, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify({
          score: score,
          extraData: extraData,
        }),
      })
        .then((response) => resolve(response.data))
        .catch((error) => reject(error));
    });
  }

  async getLeaderboardPlayerEntry(code) {
    return new Promise((resolve, reject) => {
      const headers = new Headers();
      headers.append('Game-Key', this._options.gameId);
      headers.append('Player-Token', this._player.token);
      let url = `${this._options.apiDomain}/highscore/${code}/score`;
      fetchJson(url, {
        method: 'GET',
        headers: headers,
      })
        .then((response) => resolve(response.data))
        .catch((error) => reject(error));
    });
  }

  async getLeaderboardEntries(code) {
    return new Promise((resolve, reject) => {
      const headers = new Headers();
      headers.append('Game-Key', this._options.gameId);
      headers.append('Player-Token', this._player.token);
      let url = `${this._options.apiDomain}/highscore/${code}/top`;
      fetchJson(url, {
        method: 'GET',
        headers: headers,
      })
        .then((response) => resolve(response.data))
        .catch((error) => reject(error));
    });
  }
}
export default Leaderboards;
